/* eslint-disable */
export default [
	{
		title: 'Resumen General',
		isActive: false,
		children: [
			{
				title: 'Resumen',
				isActive: false,
				children: [
					{
						title: 'General',
						isActive: false,
						route: '/coaching/school/summary'
					},
					{
						title: 'Ambiente emocional',
						isActive: false,
						route: '/coaching/school/summary/categories/1'
					},
					{
						title: 'Proceso académico',
						isActive: false,
						route: '/coaching/school/summary/categories/2'
					},
					{
						title: 'Aprendizaje profundo',
						isActive: false,
						route: '/coaching/school/summary/categories/3'
					},
					{
						title: 'Aprendizaje experto',
						isActive: false,
						route: '/coaching/school/summary/categories/4'
					}
				]
			},
			{
				title: 'Progreso',
				isActive: false,
				children: [
					{
						title: 'General',
						isActive: false,
						route: '/coaching/school/progress'
					},
					{
						title: 'Todas',
						isActive: false,
						route: '/coaching/school/progress/categories'
					},
					{
						title: 'Ambiente emocional',
						isActive: false,
						route: '/coaching/school/progress/categories/1'
					},
					{
						title: 'Proceso académico',
						isActive: false,
						route: '/coaching/school/progress/categories/2'
					},
					{
						title: 'Aprendizaje profundo',
						isActive: false,
						route: '/coaching/school/progress/categories/3'
					},
					{
						title: 'Aprendizaje experto',
						isActive: false,
						route: '/coaching/school/progress/categories/4'
					}
				]
			}
		]
	},
	{
		title: 'Nivel Escolar',
		isActive: false,
		children: [
			{
				title: 'Resumen',
				isActive: false,
				children: [
					{
						title: 'General',
						isActive: false,
						route: '/coaching/academicLevels/list'
					},
					{
						title: 'Preescolar',
						isActive: false,
						route: '/coaching/academicLevels/summary/3'
					},
					{
						title: 'Primaria',
						isActive: false,
						route: '/coaching/academicLevels/summary/1'
					},
					{
						title: 'Secundaria',
						isActive: false,
						route: '/coaching/academicLevels/summary/2'
					}
				]
			},
			{
				title: 'Progreso',
				isActive: false,
				children: [
					{
						title: 'General',
						isActive: false,
						route: '/coaching/academicLevels/progress'
					},
					{
						title: 'Preescolar',
						isActive: false,
						children: [
							{
								title: 'General',
								isActive: false,
								route: '/coaching/academicLevels/progress/3'
							},
							{
								title: 'Todas',
								isActive: false,
								route: '/coaching/academicLevels/progress/3/categories'
							},
							{
								title: 'Ambiente emocional',
								isActive: false,
								route: '/coaching/academicLevels/progress/3/categories/1'
							},
							{
								title: 'Proceso académico',
								isActive: false,
								route: '/coaching/academicLevels/progress/3/categories/2'
							},
							{
								title: 'Aprendizaje profundo',
								isActive: false,
								route: '/coaching/academicLevels/progress/3/categories/3'
							},
							{
								title: 'Aprendizaje experto',
								isActive: false,
								route: '/coaching/academicLevels/progress/3/categories/4'
							}
						]
					},
					{
						title: 'Primaria',
						isActive: false,
						children: [
							{
								title: 'General',
								isActive: false,
								route: '/coaching/academicLevels/progress/1'
							},
							{
								title: 'Todas',
								isActive: false,
								route: '/coaching/academicLevels/progress/1/categories'
							},
							{
								title: 'Ambiente emocional',
								isActive: false,
								route: '/coaching/academicLevels/progress/1/categories/1'
							},
							{
								title: 'Proceso académico',
								isActive: false,
								route: '/coaching/academicLevels/progress/1/categories/2'
							},
							{
								title: 'Aprendizaje profundo',
								isActive: false,
								route: '/coaching/academicLevels/progress/1/categories/3'
							},
							{
								title: 'Aprendizaje experto',
								isActive: false,
								route: '/coaching/academicLevels/progress/1/categories/4'
							}
						]
					},
					{
						title: 'Secundaria',
						isActive: false,
						children: [
							{
								title: 'General',
								isActive: false,
								route: '/coaching/academicLevels/progress/2'
							},
							{
								title: 'Todas',
								isActive: false,
								route: '/coaching/academicLevels/progress/2/categories'
							},
							{
								title: 'Ambiente emocional',
								isActive: false,
								route: '/coaching/academicLevels/progress/2/categories/1'
							},
							{
								title: 'Proceso académico',
								isActive: false,
								route: '/coaching/academicLevels/progress/2/categories/2'
							},
							{
								title: 'Aprendizaje profundo',
								isActive: false,
								route: '/coaching/academicLevels/progress/2/categories/3'
							},
							{
								title: 'Aprendizaje experto',
								isActive: false,
								route: '/coaching/academicLevels/progress/2/categories/4'
							}
						]
					}
				]
			}
		]
	},
	{
		title: 'Idiomas',
		isActive: false,
		children: [
			{
				title: 'Resumen',
				isActive: false,
				children: [
					{
						title: 'General',
						isActive: false,
						route: '/coaching/languages/list'
					},
					{
						title: 'Español',
						isActive: false,
						route: '/coaching/languages/summary/es'
					},
					{
						title: 'Inglés',
						isActive: false,
						route: '/coaching/languages/summary/en'
					}
				]
			},
			{
				title: 'Progreso',
				isActive: false,
				children: [
					{
						title: 'General',
						isActive: false,
						route: '/coaching/languages/progress'
					},
					{
						title: 'Español',
						isActive: false,
						children: [
							{
								title: 'General',
								isActive: false,
								route: '/coaching/languages/progress/es'
							},
							{
								title: 'Todas',
								isActive: false,
								route: '/coaching/languages/progress/es/categories'
							},
							{
								title: 'Ambiente emocional',
								isActive: false,
								route: '/coaching/languages/progress/es/categories/1'
							},
							{
								title: 'Proceso académico',
								isActive: false,
								route: '/coaching/languages/progress/es/categories/2'
							},
							{
								title: 'Aprendizaje profundo',
								isActive: false,
								route: '/coaching/languages/progress/es/categories/3'
							},
							{
								title: 'Aprendizaje experto',
								isActive: false,
								route: '/coaching/languages/progress/es/categories/4'
							}
						]
					},
					{
						title: 'Inglés',
						isActive: false,
						children: [
							{
								title: 'General',
								isActive: false,
								route: '/coaching/languages/progress/en'
							},
							{
								title: 'Todas',
								isActive: false,
								route: '/coaching/languages/progress/en/categories'
							},
							{
								title: 'Ambiente emocional',
								isActive: false,
								route: '/coaching/languages/progress/en/categories/1'
							},
							{
								title: 'Proceso académico',
								isActive: false,
								route: '/coaching/languages/progress/en/categories/2'
							},
							{
								title: 'Aprendizaje profundo',
								isActive: false,
								route: '/coaching/languages/progress/en/categories/3'
							},
							{
								title: 'Aprendizaje experto',
								isActive: false,
								route: '/coaching/languages/progress/en/categories/4'
							}
						]
					}
				]
			}
		]
	},
	{
		title: 'Docentes',
		isActive: false,
		children: [
			{
				title: 'Lista',
				isActive: false,
				route: '/coaching/teachers/list'
			}
		]
	},
	{
		title: 'Administración',
		isActive: false,
		children: [
			{
				title: 'Resumen',
				isActive: false,
				route: '/coaching/admin/summary'
			},
			{
				title: 'Colegios',
				isActive: false,
				route: '/coaching/admin/schools'
			},
			{
				title: 'Cierres de visita',
				isActive: false,
				children: [
					{
						title: 'Lista',
						isActive: false,
						route: '/coaching/admin/syntheses/1',
						secondRoute: '/coaching/admin/visit-closure/'
					},
					{
						title: 'Reporte',
						isActive: false,
						route: '/coaching/admin/syntheses-report/1'
					}
				]
			},
			{
				title: 'Formaciones',
				isActive: false,
				children: [
					{
						title: 'Lista',
						isActive: false,
						route: '/coaching/admin/syntheses/2',
						secondRoute: '/coaching/admin/training/',
					},
					{
						title: 'Reporte',
						isActive: false,
						route: '/coaching/admin/syntheses-report/2'
					}
				]
			},
			{
				title: 'Diagnóstico actual',
				isActive: false,
				children: [
					{
						title: 'Lista',
						isActive: false,
						route: '/coaching/admin/syntheses/3',
						secondRoute: '/coaching/admin/diagnostic/',
					},
					{
						title: 'Reporte',
						isActive: false,
						route: '/coaching/admin/syntheses-report/3'
					}
				]
			},
			{
				title: 'Incidencias',
				isActive: false,
				route: '/coaching/admin/issues/',
				secondRoute: '/coaching/admin/issue/'
			},
			{
				title: 'Indicadores',
				isActive: false,
				children: [
					{
						title: 'Dashboard',
						isActive: false,
						route: '/coaching/admin/syntheses-dashboard/5'
					},
					{
						title: 'Lista',
						isActive: false,
						route: '/coaching/admin/syntheses/5',
						secondRoute: '/coaching/admin/indicator/',
					},
					{
						title: 'Reporte',
						isActive: false,
						route: '/coaching/admin/syntheses-report/5'
					}
				]
			},
			{
				title: 'Evaluaciones',
				isActive: false,
				route: '/coaching/admin/syntheses/6',
				secondRoute: '/coaching/admin/evaluation/'
			}
		]
	}
];



// WEBPACK FOOTER //
// ./src/staticData/sideMenu.js